import type { ICampaignsBaseScrapingConfiguration } from "app/components/campaigns/shared/CampaignsConst";

/** Trims and lowercases a keyword string for UI-layer deduplication comparisons. */
export const normalizeKeyword = (keyword: string): string => keyword.trim().toLowerCase();

const mergeUniqueValues = (currentValues: string[] | undefined, valuesToAdd: string[]): string[] => {
    return [...new Set([...(currentValues ?? []), ...valuesToAdd])];
};

export const normalizeKeywordList = (keywords: string[]): string[] => {
    return [...new Set(keywords.map((kw) => kw.trim()).filter(Boolean))];
};

/**
 * Trims keyword keys on tag and target-URL maps.
 * If two keys trim to the same string, values are merged with duplicates removed.
 */
export const normalizeKeywordMap = <TKeywordMap extends Record<string, string[]> | undefined>(
    keywordMap: TKeywordMap,
): TKeywordMap => {
    if (!keywordMap) {
        return keywordMap;
    }

    return Object.entries(keywordMap).reduce<Record<string, string[]>>((acc, [keyword, values]) => {
        const normalizedKeyword = keyword.trim();
        if (normalizedKeyword) {
            acc[normalizedKeyword] = mergeUniqueValues(acc[normalizedKeyword], values);
        }
        return acc;
    }, {}) as TKeywordMap;
};

export const normalizeScrapingConfigurations = <TConfiguration extends ICampaignsBaseScrapingConfiguration>(
    scrapingConfigurations: TConfiguration[],
): TConfiguration[] => {
    return scrapingConfigurations.map((configuration) => ({
        ...configuration,
        keywords: normalizeKeywordList(configuration.keywords),
    }));
};
